import { Breadcrumb, Button, Flex, Heading } from '@applyboard/crystal-ui';
import { useProgramDetails } from '../context/ProgramDetailsContext';
import { BreadcrumbItem } from '~/utils';
import { EditOutlineIcon } from '@applyboard/ui-icons';

type ProgramDetailsHeadingProps = {
  allowedToEdit: boolean;
  setAllowedToEdit: (allowedToEdit: boolean) => void;
};
export function ProgramDetailsHeading({ allowedToEdit, setAllowedToEdit }: ProgramDetailsHeadingProps) {
  const { program, isLoadingProgram } = useProgramDetails();

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/program-catalog',
      label: 'Program Catalog',
    },
    {
      href: `/program-catalog/${program?.id}`,
      label: `Program Details - ${program?.code}`,
    },
  ] as BreadcrumbItem[];

  return (
    <Flex direction="column" gap={8}>
      {!isLoadingProgram && <Breadcrumb items={breadcrumbItems} />}
      <Flex justify="between" align="center">
        <Heading contrast="high" level={1} variant="titleL">
          {program?.name}
        </Heading>
        {!allowedToEdit ? (
          <Button
            intent="primary"
            emphasis="highlighted"
            leadIcon={EditOutlineIcon}
            onClick={() => setAllowedToEdit(true)}
          >
            Edit Program
          </Button>
        ) : null}
      </Flex>
    </Flex>
  );
}
